/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'HomeOverview';

const classes = {
  header: `${PREFIX}-header`,
  projectList: `${PREFIX}-projectList`,
  loader: `${PREFIX}-loader`,
  empty: `${PREFIX}-empty`,
};

const Root = styled(Box)(({theme}) => ({
  [`& .${classes.header}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(4), // 16px — Figma node 10282-118574 control-panel gap
    paddingTop: theme.spacing(2), // 8px — Figma header py
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(6), // 24px — Figma header px
    paddingRight: theme.spacing(6),
  },
  [`& .${classes.projectList}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2), // 8px — Figma node 10282-122152 card-to-card gap
    margin: theme.spacing(10, 0, 46, 0),
    // ScreenLayout zeroes the container gutters (full-width). Re-inset content 24px from the
    // viewport edges so cards align with the header instead of bleeding to the very edge.
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
  },
  [`& .${classes.loader}`]: {
    width: '100%',
    marginTop: theme.spacing(10),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
  },
  [`& .${classes.empty}`]: {
    marginTop: theme.spacing(10),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
  },
}));

export {classes as HomeOverviewClasses, Root as HomeOverviewRoot};
